var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { Error, Footer, Header, Loading } from '@/presentation/components';
import { SurveyResultData, surveyResultState, onSurveyAnswerState } from '@/presentation/pages/survey-result/components';
import Styles from './survey-result-styles.scss';
import { useErrorHandler } from '@/presentation/hooks';
import { useRecoilState, useSetRecoilState, useResetRecoilState } from 'recoil';
const SurveyResult = ({ loadSurveyResult, saveSurveyResult }) => {
    const resetSurveyResultState = useResetRecoilState(surveyResultState);
    const handleError = useErrorHandler((error) => {
        setState(prev => (Object.assign(Object.assign({}, prev), { surveyResult: null, isLoading: false, error: error.message })));
    });
    const [state, setState] = useRecoilState(surveyResultState);
    const setOnAnswer = useSetRecoilState(onSurveyAnswerState);
    const onAnswer = (answer) => {
        if (!state.isLoading) {
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            saveSurveyResult
                .save({ answer })
                .then(surveyResult => setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false, surveyResult }))))
                .catch(handleError);
        }
    };
    const reload = () => setState(prev => ({ isLoading: false, surveyResult: null, error: '', reload: !prev.reload }));
    useEffect(() => {
        resetSurveyResultState();
        setOnAnswer({ onAnswer });
    }, []);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const surveyResult = yield loadSurveyResult.show();
                setState(prev => (Object.assign(Object.assign({}, prev), { surveyResult })));
            }
            catch (error) {
                handleError(error);
            }
        }))();
    }, [state.reload]);
    return (React.createElement("div", { className: Styles.surveyResultWrap },
        React.createElement(Header, null),
        React.createElement("div", { "data-testid": "survey-result", className: Styles.contentWrap },
            state.surveyResult && React.createElement(SurveyResultData, { surveyResult: state.surveyResult }),
            state.isLoading && React.createElement(Loading, null),
            state.error && React.createElement(Error, { error: state.error, reload: reload })),
        React.createElement(Footer, null)));
};
export default SurveyResult;
